import {AnyAction} from "redux";
import * as actions from "../Actions/userData";

export interface IUser {
  login: string;
  userFirstName: string;
  userSurname: string;
  roleDetails: {
    role: string | null;
    programDescriptors: [IProgramDescriptors]
  };
  organization: { name: string; id: number };
  roleTypeName: string;
}

export interface IProgramDescriptors {
  original: string;
  program: string;
  dzialanie: string;
  priorytet: string;
  poziomInstytucji: string;
}

export interface IUserDataState {
  user?: IUser;
  isLoading?: boolean;
  error?: string;
  isLogged?: boolean;
}

export const userDataReducer = (
    state: IUserDataState = {},
  action: AnyAction
) => {
  switch (action.type) {
    case actions.GET_USER_DATA_REQUEST:
      return { ...state, isLoading: true };
    case actions.GET_USER_DATA_SUCCESS:
      return { ...state, isLoading: false, user: action.payload, isLogged: true };
    case actions.GET_USER_DATA_FAILED:
      return {
        ...state,
        isLoading: false,
        isLogged: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
